export default __webpack_public_path__ + "static/114-7be5f3671228366e74c93aced999047e.jpg";